module.exports = __webpack_public_path__ + "media/images/log/log-graph-kinki-96761f38feef8bec64ec7d1140466eeb.svg";